import { render, staticRenderFns } from "./Prequiz.vue?vue&type=template&id=8fcc9936&scoped=true&"
import script from "./Prequiz.vue?vue&type=script&lang=js&"
export * from "./Prequiz.vue?vue&type=script&lang=js&"
import style0 from "./Prequiz.vue?vue&type=style&index=0&id=8fcc9936&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcc9936",
  null
  
)

export default component.exports